import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { IListedTheme } from '../../../core/models/essay';

interface ThemeListState {
  themes: IListedTheme[];
  originalThemes: IListedTheme[];
  setThemes: (themes: IListedTheme[]) => void;
  setOriginalThemes: (themes: IListedTheme[]) => void;
  resetThemes: () => void;
}

export const useThemeListStore = create<ThemeListState>()(
  persist(
    (set) => ({
      themes: [],
      originalThemes: [],
      setThemes: (themes: IListedTheme[]) => set({ themes: themes }),
      setOriginalThemes: (themes: IListedTheme[]) => set({ originalThemes: themes }),
      resetThemes: () => set({ 
        themes: [], 
        originalThemes: [],
      })
    }),
    { name: 'essay-themes' }
  )
);